import React, { useState, useEffect } from 'react';
import CustomDateRangePicker, { createStaticRanges } from './custom-date-range-picker.component.jsx';
import useDateDefineds from '../../../hooks/date-defineds.hook';
import './custom-date-range-picker.styles.scss';

/**
 * Custom Date Range Picker With Inputs Component
 * Drop-in replacement for DateRangePickerWithInputs that uses react-date-range
 * Uses custom date-fns replacement utility instead of date-fns
 */
const CustomDateRangePickerWithInputs = ({
  startDate,
  endDate,
  onDateChange,
  editableDateInputs = false,
  direction = "vertical",
  startDatePlaceholder = "From",
  endDatePlaceholder = "To",
  dateFormat = "DD/MM/YYYY",
  staticRanges: customStaticRanges,
}) => {
  const defineds = useDateDefineds();

  // Default static ranges if none provided
  const defaultStaticRanges = [
    {
      label: "Current Year",
      range: () => ({
        startDate: defineds.startOfCurrentYear,
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: "Previous Year",
      range: () => ({
        startDate: defineds.startOflastYear,
        endDate: defineds.endOfPreviousYear,
      }),
    },
    {
      label: "Last 12 Months",
      range: () => ({
        startDate: defineds.startOfLastTwelveMonth,
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: "Last 6 Months",
      range: () => ({
        startDate: defineds.startOfLastSixMonth,
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: "Last 90 Days",
      range: () => ({
        startDate: defineds.startOfLastNintyDay,
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: defineds.startOfLastThirtyDay,
        endDate: defineds.endOfToday,
      }),
    },
  ];

  const staticRanges = customStaticRanges || defaultStaticRanges;
  const processedStaticRanges = createStaticRanges(staticRanges);

  const handleDateChange = (ranges, label) => {
    if (onDateChange) {
      onDateChange(ranges, label);
    }
  };

  const handleClear = () => {
    const defaultRange = {
      startDate: defineds.startOfLastTwelveMonth,
      endDate: defineds.endOfToday,
    };
    
    if (onDateChange) {
      onDateChange(
        {
          selection: {
            startDate: defaultRange.startDate,
            endDate: defaultRange.endDate,
            key: "selection",
          },
        },
        "Last 12 Months"
      );
    }
  };

  return (
    <div className="custom-date-range-picker-with-inputs">
      <CustomDateRangePicker
        startDate={startDate}
        endDate={endDate}
        onDateChange={handleDateChange}
        staticRanges={processedStaticRanges}
        editableDateInputs={editableDateInputs}
        direction={direction}
        startDatePlaceholder={startDatePlaceholder}
        endDatePlaceholder={endDatePlaceholder}
        dateFormat={dateFormat}
        showDateDisplay={true}
        showPreview={true}
      />
      <div
        className="f-12 pointer clearBlockHeight f-400"
        onClick={handleClear}
        style={{
          padding: "0.7rem",
        }}
      >
        Clear
      </div>
    </div>
  );
};

export default CustomDateRangePickerWithInputs;
